import styled from 'styled-components';
import { DefaultButton } from '../../styles/globals';
import { IThemeProvider } from '../../styles/theme';

export const SubmitInput = styled(DefaultButton)`
  width: 320px;
  border: none;
  ${({ theme }: IThemeProvider) => `
      color: ${theme.colors.neutral.primary[5]};
      background: ${theme.colors.primary[100]};
      padding: 14px ${theme.layout.spacing.centy};
      border-radius: ${theme.layout.spacing.mikro};
  `}
`;

export const IconCont = styled.span`
  ${({ theme }: IThemeProvider) => `
    margin-right: ${theme.layout.spacing.mili};

    svg {
      path {
        fill: ${theme.colors.neutral.primary[5]};
      }
    }
  `}

`;
